module.exports = __webpack_public_path__ + "static/media/services-submenu-lifeforce-food.c9612e11.png";